import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { isEmpty } from 'lodash';
import queryString from 'query-string';

import NavSelect from '../../../components/NavSelect';
import BobModal from '../../../components/BobModal';

import * as BobActions from '../../../actions/bobActions';
import * as NavigationActions from '../../../actions/navigationActions';

import * as classes from './NavigationModal.module.css';

const NavigationModal = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    closeNavSelectModal,
    companies,
    fetchNavigationClients,
    fetchNavigationEquipment,
    fetchNavigationSystems,
    fetchNavigationSites,
    history,
    menuType,
    reset,
    setActiveNavClient,
    setActiveNavEquipment,
    setActiveNavSite,
    setNavClient,
    setNavEquipment,
    setNavOptions,
    setNavSite,
    targetNavCompany,
    targetNavClient,
    targetNavSite,
    targetNavEquipment,
    targetNavSystem,
    tempAppId,
    tempChildId,
    tempParentId,
    ...props
}) => {
    const [companyList, setCompanyList] = useState([]);

    const [selectedCompany, setSelectedCompany] = useState({});
    const [selectedClient, setSelectedClient] = useState({});
    const [selectedSite, setSelectedSite] = useState({});
    const [selectedEquipment, setSelectedEquipment] = useState({});
    const [selectedSystem, setSelectedSystem] = useState({});

    const [clients, setClients] = useState([]);
    const [clientsMeta, setClientsMeta] = useState({ totalCount: 0 });
    const [sites, setSites] = useState([]);
    const [sitesMeta, setSitesMeta] = useState({ totalCount: 0 });
    const [equipment, setEquipment] = useState([]);
    const [equipmentMeta, setEquipmentMeta] = useState({ totalCount: 0 });
    const [systems, setSystems] = useState([]);
    const [systemsMeta, setSystemsMeta] = useState({ totalCount: 0 });

    useEffect(() => {
        if (activeNavClient.id) {
            setSelectedClient(activeNavClient);
        }

        if (activeNavSite.id) {
            setSelectedSite(activeNavSite);
        }
    }, []);

    useEffect(() => {
        const init = async () => {
            setSelectedCompany(activeNavCompany);
            const navigationClients = await fetchNavigationClients(activeNavCompany.id);
            setClients(navigationClients);
            setClientsMeta({ totalCount: navigationClients.length });
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        const init = async () => {
            if (!activeNavSite.id) { 
                setSelectedSite({});
            }
            setSelectedEquipment({});
            setSelectedSystem({});
            const navigationSites = await fetchNavigationSites(selectedClient.id);
            setSites(navigationSites);
            setSitesMeta({ totalCount: navigationSites.length });
        };

        if (selectedClient.id) init();
    }, [selectedClient]);

    useEffect(() => {
        const init = async () => {
            setSelectedEquipment({});
            setSelectedSystem({});

            const navigationEquipment = await fetchNavigationEquipment(selectedSite.id);
            setEquipment(navigationEquipment);
            setEquipmentMeta({ totalCount: navigationEquipment.length });

            const navigationSystems = await fetchNavigationSystems(selectedSite.id);
            setSystems(navigationSystems);
            setSystemsMeta({ totalCount: navigationSystems.length });
        };

        if (selectedSite.id) init();
    }, [selectedSite]);


    const sorter = (a, b) => {
        let itemA = a.name.toUpperCase();
        let itemB = b.name.toUpperCase();

        if (itemA < itemB) {
            return -1;
        }
        if (itemA > itemB) {
            return 1;
        }

        return 0;
    };

    useEffect(() => {
        if (companies.length) {
            const collection = companies.map(company => company.company).sort((a, b) => sorter(a, b));

            setCompanyList(collection);
        }
    }, [companies]);

    const isValidSubmit = () => {
        if (menuType === 'client') {
            if (!isEmpty(activeNavCompany) && !isEmpty(selectedClient)) {
                return false;
            }
        } else if (menuType === 'site') {
            if (!isEmpty(activeNavCompany) && !isEmpty(selectedClient) && !isEmpty(selectedSite)) {
                return false;
            }
        } else if (menuType === 'equipment') {
            if (!isEmpty(activeNavCompany) && !isEmpty(selectedClient) && !isEmpty(selectedSite) && !isEmpty(selectedEquipment)) {
                return false;
            }
        } else if (menuType === 'system') {
            if (!isEmpty(activeNavCompany) && !isEmpty(selectedClient) && !isEmpty(selectedSite) && !isEmpty(selectedSystem)) {
                return false;
            }
        }
        return true;
    };

    const handleGo = () => {
        const queryValues = queryString.parse(history.location.search);

        queryValues.appId = tempAppId;
        queryValues.parentId = tempParentId;
        queryValues.childId = tempChildId;

        switch (queryValues.childId) {
            case '15dfff21-071c-4ee6-ab53-903fdcb5996a': // site view
                queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab20abb07';
                break;
            case '4b25aeb8-75d4-4522-9f77-870ab40abb07': //equipment view
            case '383849dd-bd20-4ee2-a0e5-1b192ddc4f81': //system view
                queryValues.viewChildId = '4b25aeb8-77d4-4522-9f77-870ab40abb07';
                break;
            default:
                break;
        }

        let path = '/v2/dashboard/company';

        if (!isEmpty(selectedSystem)) {
            queryValues.system = selectedSystem.id;
            queryValues.site = selectedSite.id;
            queryValues.client = selectedClient.id;

            setActiveNavClient({ ...selectedClient });
            setActiveNavSite({ ...selectedSite });

            setNavClient({ ...selectedClient });
            setNavSite({ ...selectedSite });

            setNavOptions('client', clients, clientsMeta);
            setNavOptions('site', sites, sitesMeta);
            setNavOptions('equipment', equipment, equipmentMeta);

            path = '/v2/dashboard/system';
        } else if (!isEmpty(selectedEquipment)) {
            queryValues.equipment = selectedEquipment.id;
            queryValues.site = selectedSite.id;
            queryValues.client = selectedClient.id;

            setActiveNavClient({ ...selectedClient });
            setActiveNavSite({ ...selectedSite });
            setActiveNavEquipment({ ...selectedEquipment });

            setNavClient({ ...selectedClient });
            setNavSite({ ...selectedSite });
            setNavEquipment({ ...selectedEquipment });

            setNavOptions('client', clients, clientsMeta);
            setNavOptions('site', sites, sitesMeta);
            setNavOptions('equipment', equipment, equipmentMeta);

            path = '/v2/dashboard/equipment';
        } else if (!isEmpty(selectedSite)) {
            queryValues.site = selectedSite.id;
            queryValues.client = selectedClient.id;

            setActiveNavClient({ ...selectedClient });
            setActiveNavSite({ ...selectedSite });

            setNavClient({ ...selectedClient });
            setNavSite({ ...selectedSite });

            setNavOptions('client', clients, clientsMeta);
            setNavOptions('site', sites, sitesMeta);
            setNavOptions('equipment', equipment, equipmentMeta);

            path = '/v2/dashboard/site';
        } else if (!isEmpty(selectedClient)) {
            queryValues.client = selectedClient.id;

            setActiveNavClient({ ...selectedClient });

            setNavClient({ ...selectedClient });

            setNavOptions('client', clients, clientsMeta);
            setNavOptions('site', sites, sitesMeta);
            setNavOptions('equipment', equipment, equipmentMeta);

            path = '/v2/dashboard/client';
        }

        if (tempAppId === '1710345b-cf28-4a02-9bf4-df9209ff29cb') {
            path = '/v2/dashboard/core/entities';
        } else if (tempAppId === '46d93819-f375-4d5c-b117-bb374c032862') {
            path = '/v2/dashboard/energy';
        }

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${path}?${queryValuesString}`);
        closeNavSelectModal();
    };

    const searchClients = async (parentId, searchTerm) => {
        const navigationClients = await fetchNavigationClients(activeNavCompany.id, { searchFilter: searchTerm.searchFilter });
        setClients(navigationClients);
        setClientsMeta({ totalCount: navigationClients.length });
    };

    const searchSites = async (parentId, searchTerm) => {
        const navigationSites = await fetchNavigationSites(selectedClient.id, { searchFilter: searchTerm.searchFilter });
        setSites(navigationSites);
        setSitesMeta({ totalCount: navigationSites.length });
    };

    const searchEquipment = async (parentId, searchTerm) => {
        const navigationEquipment = await fetchNavigationEquipment(selectedSite.id, { searchFilter: searchTerm.searchFilter });
        setEquipment(navigationEquipment);
        setEquipmentMeta({ totalCount: navigationEquipment.length });
    };

    const searchSystems = async (parentId, searchTerm) => {
        const navigationSystems = await fetchNavigationSystems(selectedSite.id, { searchFilter: searchTerm.searchFilter });
        setSystems(navigationSystems);
        setSystemsMeta({ totalCount: navigationSystems.length });
    };

    return (
        <BobModal
            title="Navigation"
            confirmText="Ok"
            onClose={closeNavSelectModal}
            onConfirm={handleGo}
            disabled={isValidSubmit()}
        >
            <div className={classes.Container}>
                <NavSelect
                    disabled
                    fetchChildren={fetchNavigationClients}
                    isFromModal={true}
                    results={companyList}
                    setTarget={setSelectedCompany}
                    targetId={selectedCompany.id}
                    targetName={selectedCompany.name}
                    title={'Company'}
                />
                {menuType === 'site' || menuType === 'equipment' || menuType === 'client' || menuType === 'system' ?
                    <NavSelect
                        fetchChildren={fetchNavigationSites}
                        isFromModal={true}
                        meta={clientsMeta}
                        parentId={activeNavCompany.id}
                        results={clients}
                        search={searchClients}
                        setTarget={setSelectedClient}
                        targetId={selectedClient.id ? selectedClient.id : ''}
                        targetName={selectedClient.name ? selectedClient.name : ''}
                        title={'Client'}
                        isNavModal={true}
                    /> : ''
                }
                {menuType === 'site' || menuType === 'equipment' || menuType === 'system' ?
                    <NavSelect
                        fetchChildren={menuType === 'system' ? fetchNavigationSystems : fetchNavigationEquipment}
                        isFromModal={true}
                        meta={sitesMeta}
                        parentId={selectedClient.id}
                        results={sites}
                        search={searchSites}
                        setTarget={setSelectedSite}
                        targetId={selectedSite.id ? selectedSite.id : ''}
                        targetName={selectedSite.name ? selectedSite.name : ''}
                        title={'Site'}
                        isNavModal={true}
                    /> : ''
                }
                {menuType === 'equipment' ?
                    <NavSelect
                        entityType={'equipment'}
                        meta={equipmentMeta}
                        isFromModal={true}
                        parentId={selectedSite.id}
                        results={equipment}
                        search={searchEquipment}
                        setTarget={setSelectedEquipment}
                        targetId={selectedEquipment.id ? selectedEquipment.id : ''}
                        targetName={selectedEquipment.name ? selectedEquipment.name : ''}
                        title={'Equipment'}
                        isNavModal={true}
                    /> : ''}
                {menuType === 'system' ?
                    <NavSelect
                        entityType={'system'}
                        meta={systemsMeta}
                        isFromModal={true}
                        parentId={selectedSite.id}
                        results={systems}
                        search={searchSystems}
                        setTarget={setSelectedSystem}
                        targetId={selectedSystem.id ? selectedSystem.id : ''}
                        targetName={selectedSystem.name ? selectedSystem.name : ''}
                        title={'System'}
                        isNavModal={true}
                    /> : ''}
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavClient:    state.bob.activeNavClient,
        activeNavEquipment: state.bob.activeNavEquipment,
        activeNavSite:      state.bob.activeNavSite,
        companies:          state.core.companies,
        navClients:         state.bob.navClients,
        navClientsMeta:     state.bob.navClientsMeta,
        navEquipment:       state.bob.navEquipment,
        navEquipmentMeta:   state.bob.navEquipmentMeta,
        navSites:           state.bob.navSites,
        navSitesMeta:       state.bob.navSitesMeta,
        navSystems:         state.bob.navSystems,
        navSystemsMeta:     state.bob.navSystemsMeta,
        targetNavClient:    state.bob.targetNavClient,
        targetNavCompany:   state.bob.targetNavCompany,
        targetNavEquipment: state.bob.targetNavEquipment,
        targetNavSite:      state.bob.targetNavSite,
        targetNavSystem:    state.bob.targetNavSystem
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...NavigationActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigationModal));
